let ocClient = null;

export const getOcClient = () => ocClient;

export default {
  useOpenClassroomsClientApi(ocClientApi) {
    ocClient = ocClientApi;
  },
};
